import React from 'react';
import { Row } from 'react-flexbox-grid';
import { Checkbox } from 'antd';
import tick from '../../../assets/Tick.png';

const ipscss = {
    marginLeft: '0px',
    marginRight: '0px'
}
const PreEFormAssetMapping = (props) => {
    const {asset,selected,formId,currentFormId, onChangeAssetId,saveVisibleText,preEFormMapping, setActive, setHeight} = props;

return(

    <Row style={ipscss} className= {`pre-status--row ${asset.selected && asset.formId === currentFormId ? 'selected' : ''} ${!asset.formId || asset.formId === 0 || asset.formId === currentFormId ? '' : 'signed'}`}>
        <div className="tasklist--checkbox">
            {!asset.formId || asset.formId === 0 || asset.formId === currentFormId ?
            <Checkbox
            disabled={saveVisibleText}
            checked = {asset.selected}
            onClick = {() => (!asset.formId || asset.formId === 0 || asset.formId === currentFormId) ? onChangeAssetId(asset,preEFormMapping.ipsLocationId, setActive, setHeight): null}/>
            :
            <span className={"tick--signed"}><img src={tick} alt="Tick"/></span>}
        </div>


        <div className="col-xs">
            {(asset.deleteFlag === 'P') ?  <span style={{color:'red'}}>{asset.assetName}</span> :
                (asset.deleteFlag === 'B') ? <b>{asset.assetName}</b> : asset.assetName}
        </div>
        <div className="col-xs" style={{textAlign: "center"}}>
            {(asset.deleteFlag === 'P') ?  <span style={{color:'red'}}>VERIFY IPS DATA</span> :
                (asset.deleteFlag === 'B') ? <b>VERIFY IPS DATA</b> : asset.assetGroupName}
        </div>
        <div className="col-xs" style={{textAlign: "center"}}>
            {asset.assetStatus}
        </div>

    </Row>
)
}
export default PreEFormAssetMapping;
